import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-female-yoga-al',
	options: {
		userFlags: ['hasAccessToYogaVideos'],
		userTags: ['yoga'],
	},
	landing: {
		ids: ['loader-yoga-f', 'age-yoga-f'],
		route: {
			path: '/yoga-f-al',
			name: 'female-yoga-funnel-al',
		},
	},
	funnel: {
		id: 'ob-female-activity-chair-yoga-al',
		route: {
			path: '/yoga-f-al/ob/:page(.*)?',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'female-activity-chair-yoga-al',
		},
		slug: 'activity-female-yoga-al',
		theme: 'light',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-yoga-f-al',
	},
	upsell: {
		routeNames: ['upsell-yoga-f'],
	},
	upgrade: {
		routeName: null,
	},
}

export default appAreaConfig
